import PropTypes from 'prop-types';
import React from 'react';
import { CALENDAR_SOCIAL_CUE } from '../../../../brands/default/content/components/deal';
import { useSocialCues } from '../../../../helpers/deals';
import {
  getBackendSocialCueMessage,
  getRedTextDealSocialCue,
} from '../../../../helpers/socialCues';
import SocialCueMainDeal from '../../SocialCueMainDeal';

const CalendarSocialCue = ({ deal }) => {
  const socialCuesData = useSocialCues(deal.id);
  const { authentic } = CALENDAR_SOCIAL_CUE;

  return (
    <>
      <SocialCueMainDeal
        className="main-deal-social-cue--assure"
        cue={
          deal.display?.bought && deal.totalBought === 0
            ? deal.newdealMessageTag
            : ''
        }
      />
      <SocialCueMainDeal
        className="main-deal-social-cue--alert"
        cue={getRedTextDealSocialCue({
          deal,
        })}
        isStarMarked
      />
      <SocialCueMainDeal
        className="main-deal-social-cue--assure"
        cue={getBackendSocialCueMessage(socialCuesData)}
      />
      <SocialCueMainDeal
        className="main-deal-social-cue--authentic"
        cue={deal.display?.previousDeal ? authentic : ''}
      />
    </>
  );
};

CalendarSocialCue.propTypes = {
  deal: PropTypes.object.isRequired,
};

export default CalendarSocialCue;
